export default {
    title: "Pinta Con Música",
    GAC_presents: "Google Arts & Culture presenta",
    about01:
        "Pinta Con Música es una experiencia interactiva que conecta dos formas de expresión artística muy importantes: la pintura y la composición musical.",
    about02: "Gracias al aprendizaje automático, con la tecnología de ",
    about03: "la biblioteca DDSP",
    about04:
        "(procesamiento digital de señales diferenciable) de Magenta, el movimiento de las pinceladas se traduce en notas musicales que se ejecutan con los instrumentos que elijas.",
    about05:
        "Una amplia gama de lienzos sensoriales, desde el cielo hasta el océano, llevarán tu composición a otro nivel con la incorporación de efectos especiales de sonido exclusivos para cada ambiente.",
    ok: "Ok",
    share_msg:
        "Transforma tu pincel en instrumentos musicales con Google Arts & Culture ",
    change_atmosphere: "Cambiar de lienzo",
    atmosphere_subtitle: "¿Dónde te gustaría pintar con música?",
    in_the_sky: "En el cielo",
    underwater: "Bajo el agua",
    on_the_street: "En la calle",
    on_paper: "En papel",
    shared_welcome:
        "Escucha mi composición musical pintada, con tecnología de aprendizaje automático.",
    create_my_own: "Crear una composición",
    ios_message01: "Para escuchar tu composición, abre",
    ios_message02: "g.co/paintwithmusic",
    ios_message03: "en una computadora o un dispositivo Android",
    share_your_masterpiece: "Comparte tu obra maestra con el mundo.",
    try_other_instrument: "Prueba otro instrumento.",
    loading_flute: "Limpiando la flauta",
    loading_violin: "Afinando el violín",
    loading_saxo: "Lustrando el saxofón",
    loading_trumpet: "Preparando la trompeta",
    loading_birds: "Llamando a las aves",
    loading_AI: "Activando la IA",
    loading_whales: "Atrayendo a las ballenas",
    loadding_spray: "Agitando pintura en spray",
    canvas_full: "Tu lienzo está lleno.",
    remove_items: "Quita algunas figuras para continuar dibujando.",
    flute: "Flauta",
    violin: "Violín",
    saxophone: "Saxofón",
    trumpet: "Trompeta",
    guitar: "Guitar",
    xylophone: "Xylophone",
    birds: "Sello Aves",
    whale: "Sello Ballena",
    scratch: "Sello Rayón",
    yo: "Sello Hola",
    seal: "Sello",
    toggle_grid: "Alternar guía de notas",
    undo: "Deshacer",
    clear_canvas: "Borrar lienzo",
    clear: "Borrar",
    back: "Volver",
    turn_device: "Gira el dispositivo para tener una mejor experiencia",
    info_scale:
        "Esta es una escala heptatónica, formada por 7 notas por octava. Las escalas heptatónicas más conocidas son la escala mayor y la escala menor armónica, muy comunes en la música occidental.",
    info_japanese_scale:
        "Esta es una escala Hirajōshi, de origen japonés. Fue creada por Yatsuhashi Kengyō y adaptada de la música con shamisen. Originalmente, se usaba esta escala para afinar el instrumento koto.",
    atmosphere_warning_title: "¡Atención!",
    atmosphere_warning_text: "Si cambias de lienzo, se borrará tu pintura",
    safari_warning: "Prueba otro navegador para tener una mejor experiencia.",
    go_back: "Volver",
    about: "Información",
    share: "Compartir",
    toggle_play_pause: "Alternar Reproducir y Pausar",
    generating_shared_strokes: "Generando archivos de audio",
};